import React, { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { Radio, FormControlLabel } from '@mui/material';

export const RadioCustom = forwardRef(({ control, name, rules, label, color, disabled, wrapperStyles, ...rest }, ref) => {
    return (
        <Controller
            key={control}
            control={control}
            name={name}
            disabled={disabled}
            rules={rules}
            render={({ field }) => (
                <FormControlLabel
                    className="radio-wrapper"
                    label={label}
                    {...rest}
                    style={wrapperStyles}
                    ref={ref}
                    control={
                        <Radio
                            {...field}
                            checked={field?.value === rest?.value}
                            value={rest?.value}
                            disabled={disabled}
                            style={{ color: color || '#347AF0' }}
                            onChange={(e) => field?.onChange(e.target.value)}
                        />
                    }
                />
            )}
        />
    );
});

RadioCustom.displayName = 'RadioCustom';
